import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
import currentUserState from './current-user-state.js';
const currentUserStationListState = buildServiceState({
    allowEmptyRequest: true,
    key: 'currentUserStationList',
    requireEmployee: true,
    service: Core.ListStationsForOrganizationUnit,
    beforeRequest: ({ req, get }) => {
        // The requireEmployee check above will ensure the user is available
        //
        const currentUser = get(currentUserState.response);
        if (!currentUser.User.CurrentOrganizationID) {
            throw new Error('Current user has no current organization');
        }
        const newRequest = {
            ...req,
            OrganizationUnitID: currentUser.User.CurrentOrganizationID,
        };
        return newRequest;
    },
});
export default currentUserStationListState;
//# sourceMappingURL=current-user-station-list-state.js.map